import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
export var SubtitleSimple = styled.div.withConfig({
  displayName: "Subtitle__SubtitleSimple",
  componentId: "sc-1i0tj6c-0"
})(["display:flex;align-items:baseline;& > :first-child{margin-top:0;span{", " ", "}}> span{margin-left:8px;", "}"], getFont(3), maxMediaQueries.phablet(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        ", "\n      "])), getFont(2)), maxMediaQueries.phablet(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      ", "\n    "])), getFont(-2)));
export var Subtitle = styled.div.withConfig({
  displayName: "Subtitle",
  componentId: "sc-1i0tj6c-1"
})(["margin-bottom:12px;font-size:15px;line-height:17px;color:", "95;"], function (_ref) {
  var theme = _ref.theme;
  return theme.colors.uiDD;
});
export var SubtitleISIN = styled.span.withConfig({
  displayName: "Subtitle__SubtitleISIN",
  componentId: "sc-1i0tj6c-2"
})(["color:currentColor;"]);
export var SubtitleClassname = styled.span.withConfig({
  displayName: "Subtitle__SubtitleClassname",
  componentId: "sc-1i0tj6c-3"
})(["color:currentColor;text-transform:lowercase;"]);